export default __webpack_public_path__ + "static/media/orange_listen.00ae1717.svg";